/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { Label } from "@fitinsur/components";

import * as Styled from "./styles";

function handleColumns({
  layoutConfig,
  mc,
  getDescription,
  setColumns,
  errors,
}) {
  if (!layoutConfig) return;

  if (!layoutConfig.view || !Array.isArray(layoutConfig.view)) {
    mc.error(getDescription("DOMAINS", 1293));
    return;
  }

  let columnsConfig = layoutConfig.view
    .sort((a, b) => a.column - b.column)
    .map((column) => {

      return {
        title: column.header,
        key: column.body,
        minWidthInPixel: 150,
        paddingRight: 8,
        notLastColumnAlign: true,
        component: (item) => (
          <Label  wordWrap fontSize={12}>
            {Array.isArray(item[column.body]) && typeof column.index === "number" ? item[column.body][column.index] : item[column.body]}
          </Label>
        ),
      };
    });

  if (errors && errors.length > 0) {
    columnsConfig.push({
      title: "Erros",
      key: "errors",
      minWidth: 14,
      notLastColumnAlign: true,
      component: (item) => (
        <>
          {item?.errors?.map((error) => (
            <Label color="red" key={error} fontSize={12}>
              {error}
            </Label>
          ))}
        </>
      ),
    });
  }

  setColumns(columnsConfig);
}

function renderDragMessage({ getDescription, isDragActive, isDragReject }) {
  if (!isDragActive) {
    return (
      <Styled.UploadMessage>
        {getDescription("DOMAINS", 1129)}{" "}
      </Styled.UploadMessage>
    );
  }

  if (isDragReject) {
    return (
      <Styled.UploadMessage type="error">
        {getDescription("DOMAINS", 1130)}
      </Styled.UploadMessage>
    );
  }

  return (
    <Styled.UploadMessage type="success">
      {getDescription("DOMAINS", 1131)}
    </Styled.UploadMessage>
  );
}

function handleRejectEvent({ event, mc, getDescription }) {
  if (event.length > 1) return mc.error(getDescription("DOMAINS", 1134));

  if (event[0].errors[0].code === "file-invalid-type") {
    return mc.error(getDescription("DOMAINS", 1135));
  }
}

async function handleImport({ files, setFile, loading, saveDocumentParams }) {
  loading.start();

  const file = files[0];

  if (!file) {
    loading.stop();
    return;
  }

  setFile(file);
  await saveDocumentParams({ file, isDraft: true });

  loading.stop();
}

const events = {
  handleColumns,
  renderDragMessage,
  handleRejectEvent,
  handleImport,
};

export { events };
